import PropTypes from 'prop-types';
import React from 'react';
import {MenuItem, Dropdown} from 'react-bootstrap';
import './FastDropdown.scss';
import _ from 'lodash';

function FastDropdown({
  placeholder,
  onSelect,
  styleMenu,
  labelKey,
  selectedItem,
  value,
  disabled,
  directionDrop,
  styleInput,
  styleContent,
  options,
  valueKey,
}) {
  const handleSelect = (itemKey) => {
    const item = _.find(options, (o) => o[valueKey] === itemKey);
    if (item.disabled) return;
    if (!onSelect) return;
    onSelect(itemKey, item);
  };

  const getValue = () => {
    let item = {};
    if (options.length === 0) return item;
    item = _.find(options, (o) => o[valueKey] === value);
    return item;
  };

  const getIsSelected = (item) => {
    if (!selectedItem && value === -1) return false;

    if ((selectedItem && item[valueKey] === selectedItem[valueKey]) || item[valueKey] === value) return true;

    return false;
  };

  const generateOptions = () => {
    const optionsItems = [];
    if (options.length === 0) return null;
    for (let i = 0; i < options.length; i++) {
      const item = options[i];
      const _props = {
        key: i,
        style: {backgroundColor: 'transparent'},
        className: `cmon-FmlxDropdown-item${getIsSelected(item) ? ' selected' : ''}`,
        eventKey: item[valueKey],
        labelKey: item[labelKey],
        disabled: item.disabled,
      };
      optionsItems.push(
        // eslint-disable-next-line react/jsx-props-no-spreading
        <MenuItem {..._props} key={i}>
          {item[labelKey]}
        </MenuItem>,
      );
    }
    return optionsItems;
  };

  return (
    <div className="cmon-FmlxDropdown-Wrapper">
      <Dropdown
        id="dropdown-custom"
        onSelect={handleSelect}
        style={styleContent}
        disabled={disabled}
        className={`cmon-FmlxDropdown${disabled ? ' disabled' : ''}`}
      >
        <Dropdown.Toggle style={styleInput} className={`cmon-FmlxDropdown-toggle${disabled ? ' disabled' : ''}`}>
          {selectedItem && <span className="cmon-FmlxDropdown-label">{selectedItem[labelKey]}</span>}
          {value !== -1 && <span className="cmon-FmlxDropdown-label">{getValue()[labelKey]}</span>}
          {!selectedItem && value === -1 && <span className="cmon-FmlxDropdown-label placeholder">{placeholder}</span>}
        </Dropdown.Toggle>
        <Dropdown.Menu style={styleMenu} className={`cmon-FmlxDropdown-menus ${directionDrop}`}>
          {generateOptions()}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

FastDropdown.propTypes = {
  onSelect: PropTypes.any,
  styleInput: PropTypes.any,
  placeholder: PropTypes.any,
  options: PropTypes.any,
  styleMenu: PropTypes.any,
  value: PropTypes.any,
  valueKey: PropTypes.any,
  labelKey: PropTypes.any,
  selectedItem: PropTypes.any,
  styleContent: PropTypes.any,
  disabled: PropTypes.any,
  directionDrop: PropTypes.string,
};

FastDropdown.defaultProps = {
  onSelect: null,
  styleInput: {},
  placeholder: 'Select...',
  options: [
    {
      Id: 0,
      Name: 'A',
    },
  ],
  styleMenu: {},
  valueKey: 'Id',
  labelKey: 'Name',
  selectedItem: null,
  value: -1,
  styleContent: {},
  disabled: false,
  directionDrop: 'down', // 'up' | 'left' | 'right' | 'down'
};

export default FastDropdown;
